
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/layout/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-layout-demo-children","pages-pages-reference-layout-demo-layoutmode","pages-pages-reference-layout-demo-nest","pages-pages-reference-layout-demo-suffixandprefix","pages-pages-reference-layout-demo-slot"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/layout/index.md?type=demo')
};